export default __webpack_public_path__ + "static/ecommerce-cover-1--cb4e2d3a09a7df5aa1cd51e03eafe396.png";